import { call, put } from "redux-saga/effects";

import actions from "@/actions";
import { Api } from "@/utils";

const messages = {
    success: "Dim test started successfully",
    defaultError: "Failed to start dim test",
};

/**
 * Starts a dim test for a control group at the specified light level.
 *
 * @param root0 - The action.
 * @param root0.payload - The dim test parameters.
 * @param root0.payload.group - The control group to dim test.
 * @param root0.payload.lightLevel - The light level to test at.
 * @yields Calls the dimming API and dispatches status updates.
 */
function* startDimTest({ payload: { group, lightLevel } }) {
    try {
        yield call(
            Api.post,
            `v1/control-groups/${group.groupID}/dim-test`,
            { lightLevel },
            {},
            { parseErrorBody: true },
        );

        yield put(
            actions.map.general.setDimTestStatus({
                status: "success",
                message: messages.success,
            }),
        );
    } catch (err) {
        yield put(
            actions.map.general.setDimTestStatus({
                status: "error",
                message: err.cause?.errorBody?.error ?? messages.defaultError,
            }),
        );
    }
}

export default startDimTest;
